import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import { CustomInputGroupPrepend } from './CustomizableInput';

interface WithCurrencyProps {
  children: ReactNode;
  currency: string;
  isCustomized?: boolean;
}

export const WithCurrency: FC<WithCurrencyProps> = ({ children, currency, isCustomized }) => (
  <div className="input-group">
    {isCustomized && <CustomInputGroupPrepend />}
    <div className="input-group-text">
      <span className={classNames('input-group-text', { 'text-info': isCustomized })}>{currency}</span>
    </div>
    {children}
  </div>
);
